import SafariStub from "../SafariStub";

function Mikumi() {
  return (
    <SafariStub
      title="Mikumi National Park"
      lead="An accessible southern park with open plains and solid game viewing, useful as a shorter southern safari."
      points={[
        "Easier access from Dar es Salaam routes",
        "Good for shorter southern itineraries",
        "Can link toward Ruaha or the coast",
      ]}
      parentTo={"/safaris/southern-circuits"}
      parentLabel="Southern Circuit"
    />
  );
}

export default Mikumi;
